import { Box, Button, ButtonGroup, Progress, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { UtagHelper, UtagType } from '../../utils/UtagHelper';
import { useGlobalState } from '../../state/state';
import { sources } from '../../api/sources';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Pages } from '../../utils/constants';
import walletImg from '../../assets/Wallet.svg';

export const MembershipWallet = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [tags] = useGlobalState('tags');
  const [finishLoadingProps, setFinishLoadingProps] = useState({ finished: true, onFinish: () => {} });
  const history = useHistory();

  function isEligibleIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }
  function isEligibleAndroid() {
    return /Android/.test(navigator.userAgent);
  }

  const onRequestAppleWallet = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'membership card', {
      cta: 'my account:account maintenance:replacement card:membership card-add to wallet',
    });
    setFinishLoadingProps({ finished: false, onFinish: () => {} });
    const response = await sources.getAppleWallet();
    setFinishLoadingProps({ finished: true, onFinish: () => {} });

    if (response && response.status == 'success' && response?.data) {
      try {
        const pkPass = response?.data;
        const binaryData = atob(pkPass); // Decode base64 to binary string
        const byteArray = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          byteArray[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: 'application/vnd.apple.pkpass' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'Membership.pkpass';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log('Failed to get digital wallet');
        history.push(Pages.SorryPage);
      }
    } else {
      console.log('Failed to get digital wallet');
      history.push(Pages.SorryPage);
    }
  };
  const onRequestAndroidWallet = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'membership card', {
      cta: 'my account:account maintenance:replacement card:membership card-add to wallet',
    });
    setFinishLoadingProps({ finished: false, onFinish: () => {} });
    const response = await sources.getAndroidWallet();
    setFinishLoadingProps({ finished: true, onFinish: () => {} });
    if (response && response.status == 'success' && response?.data) {
      try {
        const pkPass = response?.data;
        const binaryData = atob(pkPass); // Decode base64 to binary string
        const wallet = JSON.parse(binaryData);
        const walletUrl = wallet?.saveToWalletUrl;

        const a = document.createElement('a');
        a.href = walletUrl;
        a.target = '_blank';

        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(walletUrl);
      } catch (error) {
        console.log('Failed to get digital wallet');
        history.push(Pages.SorryPage);
      }
    } else {
      console.log('Failed to get digital wallet');
      history.push(Pages.SorryPage);
    }
  };

  return (
    <>
      <ButtonGroup id="membership-wallet-buttons" sx={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
        <>
          <Stack direction="row" alignItems="flex-start">
            <Button
              visible={isEligibleAndroid}
              className="download-android-wallet-button"
              label={
                <>
                  <img src={walletImg} className="wallet-image" alt="icon" style={{ height: '24px', width: '33px' }} />
                  <Stack direction="column" alignItems="flex-start">
                    <Typography
                      sx={{
                        color: '#FFF',
                        fontWeight: '400',
                        backgroundColor: '#000',
                        fontSize: '11px',
                        textAlign: 'left',
                        justifyContent: 'left',
                        height: '8px',
                        width: '33px',
                        marginLeft: '6px',
                        lineHeight: '8px',
                        marginBottom: '2px',
                        marginTop: '1px',
                      }}
                    >
                      Add to
                    </Typography>
                    <Typography
                      sx={{
                        color: '#FFF',
                        fontWeight: '500',
                        fontSize: '0.85rem',
                        backgroundColor: '#000',
                        textAlign: 'left',
                        justifyContent: 'left',
                        height: '12.5px',
                        width: '82px',
                        marginLeft: '6px',
                        textWrap: 'nowrap',
                        lineHeight: '12.5px',
                      }}
                    >
                      Google Wallet
                    </Typography>
                  </Stack>
                </>
              }
              sx={{
                backgroundColor: '#000',
                borderColor: '#A6A6A6',
                ':hover': { backgroundColor: '#000' },
                width: '138px',
                height: '41px',
                justifyContent: 'left',
                paddingLeft: '7px',
              }}
              onClick={onRequestAndroidWallet}
            ></Button>
            <Typography
              visible={isEligibleAndroid}
              sx={{
                height: '40px',
                width: '165px',
                marginLeft: '6px',
                lineHeight: '20px',
                fontSize: '0.85rem',
                fontWeight: '500',
                textWrap: 'wrap',
              }}
            >
              Add proof of membership to Google Wallet
            </Typography>
          </Stack>
        </>
        <>
          <Stack direction="row" alignItems="flex-start">
            <Button
              visible={isEligibleIOS}
              className="download-apple-wallet-button"
              label={
                <>
                  <img src={walletImg} className="wallet-image" alt="icon" style={{ height: '24px', width: '33px' }} />
                  <Stack direction="column" alignItems="flex-start">
                    <Typography
                      sx={{
                        color: '#FFF',
                        fontWeight: '400',
                        backgroundColor: '#000',
                        fontSize: '11px',
                        textAlign: 'left',
                        justifyContent: 'left',
                        height: '8px',
                        width: '33px',
                        marginLeft: '6px',
                        lineHeight: '8px',
                        marginBottom: '2px',
                        marginTop: '1px',
                      }}
                    >
                      Add to
                    </Typography>
                    <Typography
                      sx={{
                        color: '#FFF',
                        fontWeight: '500',
                        fontSize: '0.85rem',
                        backgroundColor: '#000',
                        textAlign: 'left',
                        justifyContent: 'left',
                        height: '12.5px',
                        width: '82px',
                        marginLeft: '6px',
                        textWrap: 'nowrap',
                        lineHeight: '12.5px',
                      }}
                    >
                      Apple Wallet
                    </Typography>
                  </Stack>
                </>
              }
              sx={{
                backgroundColor: '#000',
                borderColor: '#A6A6A6',
                ':hover': { backgroundColor: '#000' },
                width: '138px',
                height: '41px',
                justifyContent: 'left',
                paddingLeft: '7px',
              }}
              onClick={onRequestAppleWallet}
            ></Button>
            <Typography
              visible={isEligibleIOS}
              sx={{
                height: '40px',
                width: '165px',
                marginLeft: '6px',
                lineHeight: '20px',
                fontSize: '0.85rem',
                fontWeight: '500',
                textWrap: 'wrap',
              }}
            >
              Add proof of membership to Apple Wallet
            </Typography>
          </Stack>
        </>
      </ButtonGroup>
      {!finishLoadingProps.finished && (
        <Box
          sx={{
            position: 'absolute',
            zIndex: 1,
          }}
        >
          <Progress variant="circular" />
        </Box>
      )}
    </>
  );
};
